<div class="bot-info-dialog" (click)="$event.stopPropagation()">
  <div class="dialog-header">
    <h2 class="dialog-title">
      <i class="fas fa-robot dialog-title-icon"></i>
      Bot Information
    </h2>
    <button type="button" class="close-btn" (click)="close()" aria-label="Close">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <div class="dialog-body">
    <dl class="info-list">
      <div class="info-item">
        <dt class="info-label"><i class="fas fa-clock label-icon"></i> Timestamp</dt>
        <dd class="info-value">{{ data.timestamp || '—' }}</dd>
      </div>
      <div class="info-item">
        <dt class="info-label"><i class="fas fa-network-wired label-icon"></i> IP Address</dt>
        <dd class="info-value info-value-mono">{{ data.ipAddress || '—' }}</dd>
      </div>
      <div class="info-item">
        <dt class="info-label"><i class="fas fa-globe label-icon"></i> IP Country</dt>
        <dd class="info-value">{{ data.ipCountry || '—' }}</dd>
      </div>
      <div class="info-item">
        <dt class="info-label"><i class="fas fa-tag label-icon"></i> Source</dt>
        <dd class="info-value">{{ data.source || '—' }}</dd>
      </div>
      <div class="info-item">
        <dt class="info-label"><i class="fas fa-external-link-alt label-icon"></i> Referrer</dt>
        <dd class="info-value">{{ data.referrer || '—' }}</dd>
      </div>
      <div class="info-item">
        <dt class="info-label"><i class="fas fa-code label-icon"></i> User Agent</dt>
        <dd class="info-value info-value-mono">{{ data.userAgent || '—' }}</dd>
      </div>
    </dl>
  </div>
</div>
